export enum PostingType {
  Reqs = 3,
  ReqsInterview = 4,
  ReqsThirdParty = 5,
  FeedThirdParty = 7,
}
